import React from 'react';
import IconBoxStyle11 from '../../IconBox/IconBoxStyle11';
import Spacing from '../../Spacing';

export default function ContactInfoSection({ sectionTitle }) {
  return (
    <div className="container">
      <h2 className="cs_fs_72 mb-0">{sectionTitle}</h2>
      <Spacing md="70" lg="50" />
      <div className="row g-4 g-xl-3 g-xxl-5">
        <div className="col-xl-4">
          <IconBoxStyle11
            title="Phone"
            subTitle={
              <a href="tel:+12256650323" className="text-decoration-none text-dark">
                (225) 665-0323
              </a>
            }
            iconSrc="/images/contact/icon_1.svg"
          />
        </div>
        <div className="col-xl-4">
          <IconBoxStyle11
            title="Email"
            subTitle={
              <a href="mailto:Ricky@freedomprola.com" className="text-decoration-none text-dark">
                Ricky@freedomprola.com
              </a>
            }
            iconSrc="/images/contact/icon_2.svg"
          />
        </div>
        <div className="col-xl-4">
          <IconBoxStyle11
            title="Location"
            subTitle={
              <a
                href="https://www.google.com/maps/place/9354+Florida+Blvd,+Walker,+LA+70785"
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none text-dark"
              >
                9354 Florida Blvd, Walker, LA 70785
              </a>
            }
            iconSrc="/images/contact/icon_3.svg"
          />
        </div>
      </div>
      <Spacing md="35" />
      {/* Start Google Map */}
      <div className="cs_map">
        <iframe
          title="Google Map"
          width="100%"
          height="450"
          style={{ border: 0 }}
          loading="lazy"
          allowFullScreen
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3405.185383046418!2d-90.86269348490713!3d30.484348981721393!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8626cfdacdb782ef%3A0x57a8f92886dc82c6!2s9354%20Florida%20Blvd%2C%20Walker%2C%20LA%2070785!5e0!3m2!1sen!2sus!4v1650412345678"
        />
      </div>
      {/* End Google Map */}
    </div>
  );
}
